import React from 'react';
import AntGridScope, { buildGridScopeSegment } from './AntGridScope';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import Calculator from '../utils/calculator';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';
import AntPopup from './AntPopup';
import AntSearchForm from './AntSearchForm';
import AntBaseForm from './AntBaseForm';
import AntGrid from './AntGrid';
import AntTabs from './AntTabs';
import AntErrorPanel from './AntErrorPanel';
import AntMessageBox from './AntMessageBox';
import AntConfig from '../utils/AntConfig';
import AntAuth from '../utils/AntAuth';

export default class extends React.Component {
    constructor(props) {
        super(props);

        var tableName = this.props.table ? this.props.table : this.props.API ? this.props.API.entityName : '';
        this.config = new AntConfig(this.props.session, tableName);
        this.config.configFields(this.props.fields);

        var actions = this.props.actions instanceof Array ? this.props.actions : [];
        actions = actions.filter((a) => AntCondition.isVisible(null, a));

        var filterByAction = actions.length > 0 ? actions[0].code : undefined;

        this.state = {
            tableName: tableName,
            error: null,
            defaultObj: {
                filterByAction: filterByAction
            },
            showSearchForm: false,
            entityDisplay: this.API && this.API.entityDisplay ? this.API.entityDisplay : this.props.entityDisplay ? this.props.entityDisplay : '',
            searchConditions: {},
            gridDataSource: null,
            formData: {
                filterByAction: filterByAction
            },
            searchByHeaderFields: [
                ...(this.props.grid.searchByHeaderFields instanceof Array ? this.props.grid.searchByHeaderFields : []),
                'filterByAction'
            ],
            searchByHeaderRequiredFields: [
                ...(this.props.grid.searchByHeaderRequiredFields instanceof Array ? this.props.grid.searchByHeaderRequiredFields : []),
                'filterByAction'
            ]
        };

        this.API = this.props.API;

        this.show = this.show.bind(this);
        this.load = this.load.bind(this);
        this.setError = this.setError.bind(this);
        this.getValidData = this.getValidData.bind(this);
        this.showAlert = this.showAlert.bind(this);

        this.initGrid = this.initGrid.bind(this);
        this.initSearch = this.initSearch.bind(this);
        this.initSize = this.initSize.bind(this);

        this.resetUI = this.resetUI.bind(this);
        this.resetGrid = this.resetGrid.bind(this);
        this.resetVisibility = this.resetVisibility.bind(this);
        this.resetDisabled = this.resetDisabled.bind(this);
        this.resetDefaultValue = this.resetDefaultValue.bind(this);
        this.resetSize = this.resetSize.bind(this);
        this.setField = this.setField.bind(this);
        this.getField = this.getField.bind(this);
        this.save = this.save.bind(this);

        this.onFieldDataChanged = this.onFieldDataChanged.bind(this);

        this.isShowing = this.isShowing.bind(this);
        this.getDataSource = this.getDataSource.bind(this);
        this.setDataSource = this.setDataSource.bind(this);
        this.updateRowToMain = this.updateRowToMain.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);

        this.beginUpdate = this.beginUpdate.bind(this);
        this.endUpdate = this.endUpdate.bind(this);
    }

    beginUpdate() {
        // AntPopup exposes show/close/size APIs, not DevExtreme's beginUpdate.
        // Child implementations may differ, so only call an update API when present.
        if (this.popup && typeof this.popup.beginUpdate === 'function') this.popup.beginUpdate();
        if (this.searchForm && typeof this.searchForm.beginUpdate === 'function') this.searchForm.beginUpdate();
        if (this.grid && typeof this.grid.beginUpdate === 'function') this.grid.beginUpdate();
    }

    endUpdate() {
        if (this.searchForm && typeof this.searchForm.endUpdate === 'function') this.searchForm.endUpdate();
        if (this.grid && typeof this.grid.endUpdate === 'function') this.grid.endUpdate();
        if (this.popup && typeof this.popup.endUpdate === 'function') this.popup.endUpdate();
    }

    async showAlert(args, onClosedCallback) {
        if (this.msgBox) this.msgBox.show(args, onClosedCallback);
    }

    isShowing() {
        return this.popup && this.popup.isShowing();
    }

    getDataSource() {
        return this.state.gridDataSource;
    }
    setDataSource(name, dataSource) {
        var old = this.state.gridDataSource;
        if (!old && dataSource) this.state.gridDataSource = dataSource;
    }

    async show(defaultObj) {
        var that = this;
        if (this.props.prepare !== false && this.API && this.API.postBatchUpdatePrepare) await this.API.postBatchUpdatePrepare(defaultObj);

        defaultObj = defaultObj ? JSON.parse(stringify(defaultObj)) : {};

        return new Promise(async (resolve) => {
            if (that.popup) {
                that.beginUpdate();

                that.setState(
                    (state) => {
                        state.error = null;
                        state.searchConditions = {};
                        state.isLoaded = false;

                        Object.keys(state.formData).forEach((key) => {
                            delete state.formData[key];
                        });
                        that.setDefaultValues(state.formData);

                        var obj = { ...defaultObj };
                        obj = JSON.parse(stringify(obj));
                        Object.keys(obj).forEach((key) => {
                            state.formData[key] = obj[key];
                        });

                        state.defaultObj = JSON.parse(stringify({ ...defaultObj }));

                        return state;
                    },
                    async () => {
                        that.resetSize();
                        that.endUpdate();

                        that.beginUpdate();

                        if (that.grid) await that.grid.cleanData();

                        that.popup.show(async () => {
                            await that.load();
                            that.resetSize();
                            if (resolve) resolve(that.state.formData);
                        });
                    }
                );
            }
        });
    }

    async load() {
        if (!this.state.isLoaded) {
            Object.keys(this.state.formData).forEach((key) => {
                delete this.state.formData[key];
            });
            this.setDefaultValues(this.state.formData);

            var obj = { ...this.state.defaultObj };
            obj = JSON.parse(stringify(obj));
            Object.keys(obj).forEach((key) => {
                this.state.formData[key] = obj[key];
            });

            if (this.searchForm && this.searchForm.load) obj = await this.searchForm.load(obj);

            Object.keys(this.state.defaultObj).forEach((key) => {
                obj[key] = this.state.defaultObj[key];
            });

            var that = this;
            this.setState(
                (state) => {
                    state.error = null;
                    state.formData = obj;
                    state.defaultObj = JSON.parse(stringify({ ...obj }));
                    return state;
                },
                async () => {
                    if (that.grid && that.grid.load) {
                        if (that.grid) await that.grid.load(null, true);
                        if (that.grid) that.grid.refresh(false);
                        that.state.isLoaded = true;
                    }
                }
            );
        }
    }

    async onGridDataLoaded() {
        await this.resetSize();
    }

    async onShowing() {
        await this.load();
        await this.resetUI(true);
    }
    async onShown() {
        await this.load();
        await this.resetUI(true);
        this.resetSize();
        setTimeout(this.resetSize, 300);
        this.endUpdate();
    }

    async setField(field, value) {
        if (this.searchForm && this.searchForm.setField) await this.searchForm.setField(field, value);
    }

    getField(field) {
        return this.state.formData[field];
    }

    async setError(content, errors) {
        if (!content && (this.state.error === null || this.state.error === undefined)) return;

        if (errors == 'TypeError: Failed to fetch') errors = { vi: 'Không thể kết nối đến hệ thống !', en: 'Can not connect to system !', fr: 'Impossible de se connecter au système !', es: '¡No se puede conectar al sistema!', id: 'Tidak dapat terhubung ke sistem!', ja: 'システムに接続できません！', zh: '无法连接到系统！', ko: '시스템에 연결할 수 없습니다!', hi: 'सिस्टम से कनेक्ट नहीं हो सकता!', ar: 'لا يمكن الاتصال بالنظام!' };

        var values = errors === undefined || errors === null ? [] : errors instanceof Array ? errors : [errors];

        content = values.length === 1 ? values[0] : content;

        this.setState(
            {
                error: content
                    ? {
                          text: String(content),
                          values: values
                      }
                    : null
            },
            () => {
                if (this.props.onError) this.props.onError(content, errors);
            }
        );
    }

    async getValidData() {
        var isValid = true;

        var searchObj = this.getSearchConditions();

        if (this.grid) {
            var config = this.props.grid;

            var rows = await this.grid.modifiedRows();

            var newRows = [];

            if (rows instanceof Array) {
                rows = rows.slice();

                if (this.props.grid.columns instanceof Array)
                    rows = rows.filter((row) => {
                        for (let j = 0; j < this.props.grid.columns.length; j++) {
                            const col = this.props.grid.columns[j];
                            if (col.isMarkSelected && col.dataField) {
                                let value = row[col.dataField];
                                return value !== null && value !== undefined;

                                // return value !== null && value !== undefined && value !== 0;
                            }
                        }

                        return true;
                    });

                if (config && config.postPreFiltering) {
                    rows = rows.filter((row) => {
                        return config.postPreFiltering(row);
                    });
                }

                rows.forEach((row) => {
                    var itemObj = {
                        actionName: searchObj ? searchObj.filterByAction : undefined
                    };

                    var postFields = ['id', 'code'];
                    postFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var rowField = field.field;
                            var postField = field.alias;

                            itemObj[postField] = row[rowField];
                        } else {
                            itemObj[field] = row[field];
                        }
                    });

                    // if (config && config.copyFromHeaderFields instanceof Array)
                    //     config.copyFromHeaderFields.forEach((field) => {
                    //         if (typeof field === 'object') {
                    //             var parentField = field.field;
                    //             var aliasField = field.alias ? field.alias : field.field;

                    //             if (this.state.formData && this.state.formData[parentField] !== undefined) {
                    //                 if (field.when && typeof field.when === 'object') {
                    //                     var isValid = AntCondition.isValid(this.state.formData, field.when, field.whenType);
                    //                     if (!isValid) return;
                    //                 }
                    //                 itemObj[aliasField] = this.state.formData[parentField];
                    //             }
                    //         } else if (this.state.formData && this.state.formData[field] !== undefined) itemObj[field] = this.state.formData[field];
                    //     });

                    Object.keys(itemObj).forEach((k) => {
                        if (
                            (typeof itemObj[k] === 'object' && itemObj[k] !== null) ||
                            typeof itemObj[k] === 'function' ||
                            itemObj[k] instanceof Array
                        )
                            itemObj[k] = undefined;
                    });

                    newRows.push({ ...itemObj });
                });
            }

            var postRequiredFields = ['id', 'code', 'actionName'];
            newRows = newRows.filter((row) => {
                var keys = Object.keys(row).filter((k) => row[k] !== undefined);
                return postRequiredFields.filter((k) => !keys.includes(k)).length <= 0;
            });

            if (config && config.postFiltering) {
                newRows = newRows.filter((row) => {
                    return config.postFiltering(row);
                });
            }

            if (config && config.postModifier) {
                newRows = newRows.map((row) => {
                    return config.postModifier(row, {
                        grid: grid,
                        popup: that
                    });
                });
            }

            for (let i = 0; i < newRows.length; i++) newRows[i].row_index = i;
            return newRows;
        }

        return [];
    }

    async onAction(button) {
        var close = false;

        if (button && button.id == 'btnSave') close = this.save();

        if (!close && this.props.onAction) close = await this.props.onAction(button);

        return close;
    }

    async save() {
        this.setError(null);

        var objs = await this.getValidData();
        if (!objs || objs instanceof Array === false || objs.length <= 0) return false;

        if (this.props.onBeforeExecute) {
            const modifiedObjs = await this.props.onBeforeExecute(objs);
            if (modifiedObjs instanceof Array) objs = modifiedObjs;
        }

        var errors = [];
        var errorContent = null;
        objs.forEach((obj) => {
            Object.keys(obj).forEach((k) => {
                if ((typeof obj[k] === 'object' && obj[k] !== null) || typeof obj[k] === 'function' || obj[k] instanceof Array) obj[k] = undefined;
            });
        });
        var result = await this.API.postBatchExecute(objs);
        if (!result || result.error || !result.data || result.data.executed_qty <= 0) {
            if (result && result.data instanceof Array && result.data.length > 0) errors = result.data;
            else if (result && typeof result.error === 'string') {
                errors = [result.error];
                errorContent = result.error;
            } else {
                errorContent = AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' });
                errors = [errorContent];
            }
        }

        if (result && result.data && result.data.executed_qty > 0) {
            if (this.props.onExecuted)
                setTimeout(
                    async (that, data) => {
                        that.props.onExecuted(data);
                    },
                    1000,
                    this,
                    result.data
                );
        }

        if (errors.length > 0) {
            if (!errorContent) errorContent = AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' });
            this.setError(errorContent, errors);
            if (this.props.onError) this.props.onError(errorContent, errors);
            else if (this.onError) this.onError(errorContent, errors);
            return false;
        }

        return true;
    }

    getSearchConditions() {
        var obj = { ...this.state.searchConditions };

        this.state.searchByHeaderFields.forEach((field) => {
            if (typeof field === 'object') {
                var parentField = field.field;
                var aliasField = field.alias ? field.alias : field.field;

                if (this.state.formData && this.state.formData[parentField] !== undefined) obj[aliasField] = this.state.formData[parentField];
            } else if (this.state.formData && this.state.formData[field] !== undefined) obj[field] = this.state.formData[field];
        });

        if (this.props.grid && this.props.grid.searchConditions) obj = { ...obj, ...this.props.grid.searchConditions };

        if (!obj.filterByAction) {
            var actions = this.props.actions instanceof Array ? this.props.actions : [];
            actions = actions.filter((a) => AntCondition.isVisible(null, a));

            var filterByAction = actions.length > 0 ? actions[0].code : undefined;
            obj.filterByAction = filterByAction;
        }
        return obj;
    }

    isAllowQuery() {
        var isAllow = this.isShowing();
        if (!isAllow) return false;

        var searchObj = this.getSearchConditions();

        this.state.searchByHeaderRequiredFields.forEach((field) => {
            if (!searchObj || searchObj[field] === undefined || searchObj[field] === null) isAllow = false;
        });

        if (!isAllow) return false;

        if (this.props.isAllowQuery && typeof this.props.isAllowQuery === 'function') isAllow = this.props.isAllowQuery();

        return isAllow;
    }

    async updateRowToMain(rowDatas, col) {
        var ar = [];
        if (typeof col.updateToMain === 'object') ar.push(col.updateToMain);
        if (col.updateToMain instanceof Array) ar.push(...col.updateToMain);

        for (let i = 0; i < ar.length; i++) {
            var rule = ar[i];

            if (rule && rule.target) {
                var targetField = rule.target;
                var calcType = rule.type;
                var targetValue = null;
                if (calcType === 'SUM') {
                    if (rule.cellFormula instanceof Array) {
                        var fm = rule.cellFormula[0];
                        var defaultNullValue =
                            rule.cellFormula[1] !== undefined && rule.cellFormula[1] !== null && typeof rule.cellFormula[1] === 'number'
                                ? rule.cellFormula[1]
                                : 0;

                        targetValue = rowDatas.reduce((total, current) => {
                            return total + Calculator.execNum(current, fm, defaultNullValue);
                        }, 0);
                    } else {
                        targetValue = rowDatas.reduce((total, current) => {
                            return total + parseFloat(current[col.dataField]);
                        }, 0);
                    }

                    await this.setField(targetField, targetValue);
                }
            }
        }
    }

    // onGridCellValueChanging(rowKey, dataField, value) {
    //     if (this.grid) {
    //         var keyField = this.grid.getKeyField();
    //         var data = this.grid.getEditedData();
    //         if (data instanceof Array) {
    //             if (this.props.grid.columns instanceof Array)
    //                 for (let i = 0; i < this.props.grid.columns.length; i++) {
    //                     var col = this.props.grid.columns[i];

    //                     if (col.parrentAllocation && col.parrentAllocation.field && col.dataField === dataField) {
    //                         var appliedAmt = data.reduce((total, current) => {
    //                             return total + current[col.dataField];
    //                         }, 0);

    //                         var applicableAmt = this.getField(col.parrentAllocation.field);
    //                         applicableAmt = parseFloat(applicableAmt);
    //                         applicableAmt = applicableAmt > appliedAmt ? applicableAmt - appliedAmt : 0;
    //                         return value > applicableAmt ? applicableAmt : value;
    //                     }
    //                 }
    //         }
    //     }
    //     return value;
    // }

    onGridCellValueChanged(colField, values) {
        if (this.grid) {
            var keyField = this.grid.getKeyField();
            var data = this.grid.getEditedData();
            if (data instanceof Array) {
                if (this.props.grid.columns instanceof Array)
                    this.props.grid.columns.forEach(async (col) => {
                        if (col.updateToMain) await this.updateRowToMain(data, col);
                    });
            }
        }
    }

    onFieldDataChanged(e) {
        this.setState(
            (state) => {
                Object.keys(e).forEach((key) => {
                    state.formData[key] = e[key];
                });
            },
            () => {
                this.beginUpdate();
                this.resetUI(true);

                if (this.grid && this.state.searchByHeaderFields instanceof Array) {
                    var loadGrid = false;

                    var keys = Object.keys(e);
                    for (let i = 0; i < keys.length; i++) {
                        if (!loadGrid) {
                            const fieldName = keys[i];
                            var found = this.state.searchByHeaderFields.find(
                                (f) => f === fieldName || (typeof f === 'object' && f.field === fieldName)
                            );
                            if (found) loadGrid = true;
                        }
                    }
                    if (loadGrid) this.grid.load();
                }

                if (this.props.onFieldDataChanged) this.props.onFieldDataChanged(e);
                this.endUpdate();
            }
        );
    }

    async resetUI(withoutUpdate) {
        if (!withoutUpdate) this.beginUpdate();
        await this.resetDefaultValue();
        await this.resetVisibility();
        await this.resetDisabled();
        await this.resetSize();
        if (!withoutUpdate) this.endUpdate();
    }

    resetVisibility() {
        if (this.searchForm) this.searchForm.resetVisibility();
        this.resetGrid();
    }

    resetGrid() {
        if (this.grid) {
            var gridCols = this.grid.getColumns();

            var cnfCols = this.props.grid && this.props.grid.columns instanceof Array ? this.props.grid.columns : [];
            cnfCols = JSON.parse(stringify(cnfCols));

            var changed = false;
            var changedField;
            gridCols.forEach((col) => {
                var found = cnfCols.find((c) => c.dataField === col.dataField);
                if (found) {
                    var old = Boolean(col.visible);
                    col.visible = AntCondition.isVisible(this.state.formData, found);

                    if (old !== col.visible) {
                        changed = true;
                        changedField = found.dataField;
                    }
                }
            });

            // if (changed)
            this.grid.resetUI();
        }
    }

    resetDisabled() {
        if (this.searchForm) this.searchForm.resetDisabled();
    }

    resetSize() {
        this.initSearch();
        this.initSize();

        if (this.searchForm) this.searchForm.updateDimensions();

        if (this.popup) this.popup.setSize(this.state.height, this.state.width);

        // this.forceUpdate();
    }

    resetDefaultValue() {
        if (this.searchForm) this.searchForm.resetDefaultValue();
    }

    setDefaultValues(formData) {
        if (this.props.search && this.props.search.items instanceof Array) {
            this.props.search.items.forEach((item) => {
                if (item && item.dataField && item.default !== undefined) AntCondition.setDefault(formData, item);
            });
        }
    }

    initGrid() {
        var gridCols = this.props.grid && this.props.grid.columns instanceof Array ? this.props.grid.columns : [];
        gridCols = JSON.parse(stringify(gridCols));

        var gridRawCols = this.props.grid && this.props.grid.columns instanceof Array ? this.props.grid.columns : [];
        gridRawCols = JSON.parse(stringify(gridRawCols));

        gridCols = gridCols.filter((col) => {
            return AntCondition.isRender(this.state.formData, col);
        });

        gridCols.forEach((col) => {
            // if (typeof col.visible !== 'object' || col.visible.type !== 'action' || !col.visible.field)

            col.rawConfig = JSON.parse(stringify(col));
            col.visible = AntCondition.isVisible(this.state.formData, col);
            col.editable = AntCondition.isEditable(this.state.formData, col);
        });
        gridCols.unshift({
            dataField: 'is_select',
            dataType: 'float',
            isMarkSelected: true,
            isSystemCol: true,
            defaultValue: { rowField: 'id' },
            visible: false,
            showInColumnChooser: false
        });

        var gridStorageKey = this.props.name
            ? this.props.name
            : this.props.entityName
            ? this.props.entityName
            : this.API && this.API.entityName
            ? this.API.entityName
            : null;
        gridStorageKey = gridStorageKey ? 'batchExecute-' + gridStorageKey : undefined;

        var url = this.props.grid && this.props.grid.url ? this.props.grid.url : '';

        var searchFields = [];

        this.state.searchByHeaderFields.forEach((f) => {
            searchFields.push(f);
        });
        if (this.props.grid && typeof this.props.grid.searchConditions === 'object' && this.props.grid.searchConditions !== null) {
            Object.keys(this.props.grid.searchConditions).map((f) => {
                searchFields.push(f);
            });
        }

        this.state.gridRawCols = gridRawCols;
        this.state.gridCols = gridCols;
        this.state.gridSearchFields = searchFields;
        this.state.gridURL = url;

        this.state.gridStorageKey = gridStorageKey;
        this.state.gridVisible = Boolean(this.props.grid);
    }

    initSearch() {
        var isVisibleSearch = this.props.search && AntCondition.isVisible(this.state.formData, this.props.search);

        var searchColCount = undefined;
        if (this.props.search) {
            searchColCount = AntCondition.getValue(this.state.formData, this.props.search.colCount);
            if (searchColCount === undefined) searchColCount = this.props.search.colCountDefault ? this.props.search.colCountDefault : 1;
        }
        var searchItems = this.state.showSearchForm && this.props.search && this.props.search.items instanceof Array ? this.props.search.items : [];
        searchItems = JSON.parse(stringify(searchItems));
        searchItems = searchItems.filter((item) => {
            return AntCondition.isVisible(this.state.formData, item);
        });

        var that = this;
        var sumSpan = searchItems.reduce((total, current) => {
            var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
            if (colSpan === undefined) colSpan = current.colSpanDefault;

            return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
        }, 0);

        if (sumSpan > searchColCount - 1)
            searchItems.unshift({
                itemType: 'empty',
                colSpan: searchColCount - 1
            });

        var actions = this.props.actions instanceof Array ? this.props.actions : [];
        actions = actions.filter((a) => AntCondition.isVisible(null, a));

        var filterByAction = actions.length > 0 ? actions[0].code : undefined;

        searchItems.unshift({
            dataField: 'filterByAction',
            dataType: 'string',
            editorType: 'antDropDownGrid',
            label: AntLocalization.translateText({ vi: 'Nghiệp vụ', en: 'Activity', fr: 'Activité', es: 'Actividad', id: 'Aktivitas', ja: 'アクティビティ', zh: '活动', ko: '활동', hi: 'गतिविधि', ar: 'نشاط' }),
            default: filterByAction,
            options: {
                values: actions,
                showClearButton: false
            }
        });

        sumSpan = searchItems.reduce((total, current) => {
            var colSpan = AntCondition.getValue(that.state.formData, current.colSpan);
            if (colSpan === undefined) colSpan = current.colSpanDefault;

            return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
        }, 0);

        var searchLineCount = Math.ceil(sumSpan / searchColCount);
        var searchHeight = 0;
        if (isVisibleSearch && searchLineCount > 0) {
            searchHeight = searchLineCount * 36 + (searchLineCount - 1) * 10;
            searchHeight += searchItems.reduce((total, current) => {
                return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
            }, 0);
        }

        this.state.searchItems = searchItems;
        this.state.searchLineCount = searchLineCount;
        this.state.searchHeight = searchHeight;
        this.state.searchVisible = isVisibleSearch;
    }

    initSize() {
        var minHeight;

        if (this.props.height instanceof Array) {
            for (let i = 0; i < this.props.height.length; i++) {
                const e = this.props.height[i];
                if (e && typeof e.when === 'object' && e.when !== null && e.value !== undefined) {
                    var isValid = AntCondition.isValid(this.state.formData, {
                        when: e.when,
                        whenType: e.whenType
                    });

                    if (isValid) {
                        minHeight = parseFloat(e.value);
                        break;
                    }
                }
            }
        } else if (typeof this.props.height === 'number') minHeight = parseFloat(this.props.height);

        // if (!minHeight) minHeight = 500;

        var height = 0;

        if (this.props.grid) {
            var hBeforeSeperator = this.state.searchVisible ? 10 : 0;
            var hAfterSeperator = 0;
            var hActionBar = 46;
            var hColHeader = 31;
            var hPager = 44;
            var hRow = 34;
            var hSeprator = 0;
            var defaultPageSize = 0;

            if (this.props.grid && this.props.grid.defaultPageSize && this.props.grid.defaultPageSize > defaultPageSize)
                defaultPageSize = this.props.grid.defaultPageSize;

            if (!defaultPageSize) defaultPageSize = 8;

            var showActionBar = this.props.grid.showActionBar !== undefined ? this.props.grid.showActionBar : true;
            var rowsNum = defaultPageSize;

            if (this.grid && this.grid.isDataLoaded()) {
                var rows = this.grid.getCachedData();
                if (rows.length === 0) rowsNum = 0;
                else if (rows.length < defaultPageSize) rowsNum = rows.length;
                if (rowsNum > 0 && rowsNum < 2) rowsNum = 2;
            }

            var gridHeight = this.state.gridVisible
                ? hBeforeSeperator +
                  (showActionBar ? hActionBar : 0) +
                  hColHeader +
                  hPager +
                  //   (rowsNum === 0 ? 130 : hRow * rowsNum) +
                  hRow * defaultPageSize +
                  hSeprator +
                  hAfterSeperator
                : 0;

            height += gridHeight;
        }

        height += this.state.searchHeight ? parseFloat(this.state.searchHeight) : 0;
        height += 10 + 46 + 20 + 47;
        height += 10;

        if (minHeight && height < minHeight) height = minHeight;

        var width = AntCondition.getValue(this.state.formData, this.props.width);
        if (width === undefined) width = this.props.widthDefault;
        if (width === undefined) width = 900;

        this.state.width = width;
        this.state.height = height;
    }

    render() {
        var that = this;

        this.initGrid();
        this.initSearch();
        this.initSize();

        var showFilter =
            this.props.grid && this.props.grid.showFilter !== undefined
                ? this.props.grid.showFilter
                : this.props.search && this.props.search.items instanceof Array && this.props.search.items.length > 0
                ? true
                : false;

        return (
            <React.Fragment>
                <AntPopup
                    ref={(ref) => {
                        this.popup = ref;
                    }}
                    session={this.props.session}
                    isGray={true}
                    height={parseInt(this.state.height)}
                    // height={this.state.error ? parseInt(height) + 40 : parseInt(height)}
                    width={this.state.width}
                    autoHeight={true}
                    autoWidth={true}
                    title={
                        this.props.title
                            ? AntLocalization.translateText(this.props.title)
                            : `${AntLocalization.translateText({ vi: 'Tạo mới', en: 'Create', fr: 'Créer', es: 'Crear', id: 'Buat', ja: '作成', zh: '创建', ko: '생성', hi: 'बनाएं', ar: 'إنشاء' })} ${this.state.entityDisplay}`
                    }
                    onAction={this.onAction.bind(this)}
                    onShown={this.onShown.bind(this)}
                    onShowing={this.onShowing.bind(this)}
                    name={`ant-batch-execute-error-${this.API.entityName}`}
                    errors={this.state.error ? this.state.error.values : undefined}
                    errorText={this.state.error ? this.state.error.text : undefined}
                    separateErrorLine={this.props.separateErrorLine}
                    widgets={[
                        {
                            id: 'btnSave',
                            type: 'button',
                            icon: 'video',
                            text: AntLocalization.translateText({ vi: 'Thực hiện', en: 'Execute', fr: 'Exécuter', es: 'Ejecutar', id: 'Jalankan', ja: '実行', zh: '执行', ko: '실행', hi: 'निष्पादित', ar: 'تنفيذ' }),
                            width: 150
                        }
                    ]}
                >
                    {/* {this.state.error && (
                        <AntErrorPanel
                            errors={this.state.error.values}
                            id={`ant-batch-creation-error-${this.API.entityName}`}
                            text={this.state.error.text}
                        />
                    )} */}
                    <Box direction="col" width="100%" height="100%">
                        {this.state.searchVisible && (
                            <BoxItem baseSize={this.state.searchHeight}>
                                <AntSearchForm
                                    ref={(ref) => {
                                        this.searchForm = ref;
                                    }}
                                    session={this.props.session}
                                    formData={this.state.formData}
                                    prepareConditions={this.props.search ? this.props.search.prepareConditions : undefined}
                                    default={this.props.search ? this.props.search.default : undefined}
                                    API={this.props.search && this.props.search.API ? this.props.search.API : this.props.API}
                                    colCount={this.props.search ? this.props.search.colCount : 1}
                                    colCountDefault={this.props.search ? this.props.search.colCountDefault : undefined}
                                    alignItemLabels={true}
                                    alignItemLabelsInAllGroups={true}
                                    // prepare={false}
                                    showLabel={true}
                                    showPlaceholder={false}
                                    table={this.props.search ? this.props.search.table : this.props.table}
                                    fields={this.props.search ? this.props.search.fields : []}
                                    items={this.state.searchItems}
                                    onFieldDataChanged={this.onFieldDataChanged}
                                    onConditionsChanged={(e) => {
                                        that.state.searchConditions = e;
                                    }}
                                    onError={this.setError}
                                />
                            </BoxItem>
                        )}
                        {this.state.searchVisible && (
                            <BoxItem baseSize={10}>
                                <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />
                            </BoxItem>
                        )}
                        {/* 
                        {this.state.headerVisible && (
                            <BoxItem baseSize={this.state.headerHeight}>
                                <AntBaseForm
                                    ref={(ref) => {
                                        this.headerForm = ref;
                                    }}
                                    session={this.props.session}
                                    formData={this.state.formData}
                                    table={this.props.header ? this.props.header.table : this.props.table}
                                    default={this.props.header ? this.props.header.default : undefined}
                                    API={this.props.header && this.props.header.API ? this.props.header.API : this.props.API}
                                    alignItemLabelsInAllGroups={this.props.header ? this.props.header.alignItemLabelsInAllGroups : undefined}
                                    labelLocation={this.props.header ? this.props.header.labelLocation : undefined}
                                    colCount={this.props.header ? this.props.header.colCount : 1}
                                    colCountDefault={this.props.header ? this.props.header.colCountDefault : undefined}
                                    prepare={false}
                                    byPassRequired={true}
                                    disabled={this.props.header && this.props.header.disabled !== undefined ? this.props.header.disabled : undefined}
                                    fields={this.props.header ? this.props.header.fields : []}
                                    items={this.state.headerItems}
                                    onFieldDataChanged={this.onFieldDataChanged}
                                    onError={this.setError}
                                />
                            </BoxItem>
                        )}

                        {this.state.headerVisible && (!this.props.header || !this.props.header.noSeparator) && (
                            <BoxItem baseSize={10}>
                                <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />
                            </BoxItem>
                        )} */}

                        {this.state.gridVisible && (
                            <BoxItem ratio={1} height={'100%'}>
                                <AntGridScope segment={buildGridScopeSegment('popup', 'batch-execute', this.props.table || (this.props.API && this.props.API.entityName))}>
                                <AntGrid
                                    ref={(ref) => {
                                        this.grid = ref;
                                    }}
                                    session={this.props.session}
                                    API={this.props.grid && this.props.grid.API ? this.props.grid.API : this.props.API}
                                    url={this.state.gridURL}
                                    table={this.props.grid && this.props.grid.table ? this.props.grid.table : this.props.table}
                                    keyExpr={'id'}
                                    height={this.props.grid ? this.props.grid.height : undefined}
                                    rowStyles={this.props.grid ? this.props.grid.rowStyles : undefined}
                                    cellStyles={this.props.grid ? this.props.grid.cellStyles : undefined}
                                    showRowActions={this.props.grid ? this.props.grid.showRowActions : undefined}
                                    rowActionPack={this.props.grid ? this.props.grid.rowActionPack : undefined}
                                    rowActions={this.props.grid ? this.props.grid.rowActions : undefined}
                                    rowActionWidth={this.props.grid ? this.props.grid.rowActionWidth : undefined}
                                    rowActionsDisplay={this.props.grid ? this.props.grid.rowActionsDisplay : undefined}
                                    rowActionPrimaryActions={this.props.grid ? this.props.grid.rowActionPrimaryActions : undefined}
                                    parentTable={this.state.tableName}
                                    parentData={this.state.formData}
                                    dataSourceHelper={this}
                                    isSearching={true}
                                    searchConditions={this.getSearchConditions.bind(this)}
                                    searchFields={this.state.gridSearchFields.length > 0 ? this.state.gridSearchFields : undefined}
                                    isAllowQuery={this.isAllowQuery.bind(this)}
                                    storageKey={this.state.gridStorageKey}
                                    // remotePaging={this.props.grid.remotePaging !== undefined ? this.props.grid.remotePaging : false}
                                    remotePaging={false}
                                    defaultPageSize={this.props.grid.defaultPageSize ? this.props.grid.defaultPageSize : 8}
                                    showPageSizeSelector={false}
                                    allowEdit={this.props.grid.allowEdit !== undefined ? this.props.grid.allowEdit : true}
                                    allowNew={this.props.grid.allowNew !== undefined ? this.props.grid.allowNew : false}
                                    fields={this.props.grid.fields}
                                    showIndex={this.props.grid.showIndex}
                                    columns={this.state.gridCols}
                                    rawColumns={this.state.gridRawCols}
                                    customSelectionValue={this.props.grid.customSelectionValue}
                                    keyboardNavigation={this.props.keyboardNavigation}
                                    actionItems={this.props.grid.actionItems}
                                    onAction={this.props.grid.onAction}
                                    onLoaded={this.onGridDataLoaded.bind(this)}
                                    ordering={this.props.grid.ordering}
                                    showDetail={this.props.grid.showDetail}
                                    showDetailOnNewWindow={true}
                                    showDetailPosition="right"
                                    showActionBar={this.props.grid.showActionBar}
                                    showRefresh={this.props.grid.showRefresh}
                                    // showSelectAll={this.props.grid.showSelectAll}
                                    showSelectAll={true}
                                    // showFilterBySelected={this.props.grid.showFilterBySelected}
                                    showFilter={showFilter}
                                    onFilterClick={() => {
                                        this.setState(
                                            {
                                                showSearchForm: !this.state.showSearchForm
                                            },
                                            () => {
                                                if (this.popup) this.popup.resetSize(this.state.height, this.state.width);
                                            }
                                        );
                                    }}
                                    showFilterBySelected={true}
                                    showSearchBar={false}
                                    // showSearchBar={this.props.grid.showSearchBar}
                                    searchBarWidth={this.props.grid.searchBarWidth}
                                    showFieldChooser={this.props.grid.showFieldChooser}
                                    locationRefresh={this.props.grid.locationRefresh}
                                    locationFilterBySelected={this.props.grid.locationFilterBySelected}
                                    locationSearchBar={this.props.grid.locationSearchBar}
                                    onDataSourceEdited={this.onGridCellValueChanged.bind(this)}
                                    // onCellValueChanging={this.onGridCellValueChanging.bind(this)}
                                    // getQueryFields={() => {
                                    //     return Array.from([id], (f) => {
                                    //         if (typeof f === 'string') {
                                    //             return String(f);
                                    //         } else if (typeof f === 'object' && f.field) return f.field;
                                    //     });
                                    // }}
                                />
                                </AntGridScope>
                            </BoxItem>
                        )}

                        {this.state.footerVisible && (!this.props.footer || !this.props.footer.noSeparator) && (
                            <BoxItem baseSize={30}>
                                <p style={{ marginBlockStart: '0px', marginBlockEnd: '30px' }} />
                            </BoxItem>
                        )}
                        {this.state.footerVisible && (
                            <BoxItem baseSize={this.state.footerHeight}>
                                <AntBaseForm
                                    ref={(ref) => {
                                        this.footerForm = ref;
                                    }}
                                    type={'Update'}
                                    session={this.props.session}
                                    formData={this.state.formData}
                                    table={this.props.footer ? this.props.footer.table : this.props.table}
                                    default={this.props.footer ? this.props.footer.default : undefined}
                                    API={this.props.footer && this.props.footer.API ? this.props.footer.API : this.props.API}
                                    alignItemLabelsInAllGroups={this.props.footer ? this.props.footer.alignItemLabelsInAllGroups : undefined}
                                    labelLocation={this.props.footer ? this.props.footer.labelLocation : undefined}
                                    colCount={this.props.footer ? this.props.footer.colCount : 1}
                                    colCountDefault={this.props.footer ? this.props.footer.colCountDefault : undefined}
                                    prepare={false}
                                    byPassRequired={true}
                                    disabled={this.props.footer && this.props.footer.disabled !== undefined ? this.props.footer.disabled : undefined}
                                    fields={this.props.footer ? this.props.footer.fields : []}
                                    items={this.state.footerItems}
                                    onFieldDataChanged={this.onFieldDataChanged}
                                    onError={this.setError}
                                />
                            </BoxItem>
                        )}
                    </Box>
                    <AntMessageBox
                        session={this.props.session}
                        ref={(ref) => {
                            this.msgBox = ref;
                        }}
                    />
                </AntPopup>
            </React.Fragment>
        );
    }
}
